export enum RepositoryState {
    Initializing = 0,
    Ready = 1,
    NotAvailable = 2
}
